// @vendors
import './brokerAlternativeFundsView.scss';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const { formatText, FormattedText } = require('core/i18n').i18n;

// @actions
import BrokerStocksByTypeActions from 'actions/brokerStocksByType';
import BrokerStocksByContractActions from 'actions/brokerWallets';
import BrokerOrdersAndMovementsActions from'actions/brokerOrdersAndMovements';
import BrokerOpenTraderActions from'actions/brokerOpenTrader';
import brokerContractState from'actions/brokerContractState';


// @commons
import { OKCover } from 'commonsComponents/OKCover';
import { OKButton } from 'components/commons/OKButton/OKButton';

// @components
import { BrokerSearchWidget } from 'components/broker/brokerSearchWidget/brokerSearchWidget';
import  BrokerTruncatedBreadcrumb from 'components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb';
import BrokerRiskIndicatorForAlternativeFunds from 'components/broker/brokerRiskIndicatorForAlternativeFunds/brokerRiskIndicatorForAlternativeFunds';
import { BrokerInvestmentSpecialist } from 'components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist';
import BrokerInformationAboutProduct from 'components/broker/brokerInformationAboutProduct/brokerInformationAboutProduct';
import BrokerAlternativeFundsIntroVideo from '../../../components/broker/brokerAlternativeFundsIntroVideo/brokerAlternativeFundsIntroVideo';
import BrokerAlternativeFundsContractTab from '../../../components/broker/brokerAlternativeFundsContractTab/brokerAlternativeFundsContractTab';
import BrokerInternalTransferFundsActions from 'actions/brokerInternalTransferFunds';
import BrokerProductFiltersSearchActions from 'actions/brokerProductFiltersSearch';
import BrokerSearchWidgetActions from 'actions/brokerSearchWidget';

// @assets
import numberOne from 'assets/images/number_one_red.svg';
import numberTwo from 'assets/images/number_two_red.svg';
import numberThree from 'assets/images/number_three_red.svg';
import numberFour from 'assets/images/number_four_red.svg';

// @constants
import {
    ALTERNATIVE_FUNDS,
    MYPROFILE_BROKER_URL,
    CNMV_URL,
    PROC_BROKER_FUNDS_PG_NAME,
    MYPROFILE_BROKER_EXPLORE_ALTERNATIVE_FUNDS_URL,
} from 'constants/index';

// @helpers
import {  getPublicSiteUrl } from 'core/apiURLBuilder';
import { taggingEventHandled } from 'utilities/taggingEventHandled';
import { recordPage, PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME } from 'utilities/tagging';

const BrokerAlternativeFundsView = ({
    history,
    immBrokerMyInvestments,
    getStocksByType,
    getStocksContracts,
    immAccounts,
    immBrokerWallets,
    getStocksByContract,
    postWalletAlias,
    setOrdersAndMovementsAccessFrom,
    setOrdersAndMovementsContract,
    onOpenTraderClick,
    getContractState,
    immBrokerContractState,
    immBrokerLandingLoader,
    resetSpecificProduct,
    onInternalTransferFundsClick,
    handleShowSearchWidget,
}) => {
    useEffect(() => {
        getStocksByType();
        getStocksContracts();
        const taggingData = {
            event_name: "view",
            pageName: "/alternativeFunds/landing",
            serviceType: "productInformation",
            interactionType: "screen",
            }
        recordPage(taggingData)
    }, []);

    const handleBuySearchClick = () => {
        taggingEventHandled(PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME, 'informationFooterLink');
        resetSpecificProduct('ALTERNATIVE_FUNDS')
        history.push(MYPROFILE_BROKER_EXPLORE_ALTERNATIVE_FUNDS_URL);
    }

    const actionLinkButton = (
        <div className="broker-general-view__action-link-btn col-sm-4">
            <OKButton modifier="primary" onClick={handleBuySearchClick}>
                <FormattedText value="broker-buySellBtnText" />
            </OKButton>
        </div>
    );

    const searchButton = (
        <div className="broker-general-view__action-link-btn col-sm-8">
            <OKButton
                modifier="secondary"
                leftIcon="icon-s-buscar"
                block={true}
                onClick={() => {
                    handleShowSearchWidget();
                }}
            >
                <FormattedText value="brokerSearchWidget-brokerSearchWidget_searchAlternativeFunds" />
            </OKButton>
        </div>
    );
    const immStocksByType = immBrokerMyInvestments.get('products');
    const alternativeFunds = immStocksByType.get('alternativeFunds');
    const emptyStocks = !alternativeFunds || alternativeFunds.get('stocks').size === 0;
    const isAltFundTabs = !(!immBrokerMyInvestments.get('isFetching')&& emptyStocks
)
    const fundsCTAsObject = !immBrokerMyInvestments.get('isFetching') && !isAltFundTabs ? (
        <div className="row">
            <div className="col-md-12 broker-general-view__landing-action-link-group broker-alternative-funds-view__section-buttons">
                {searchButton}
                {actionLinkButton}
            </div>
        </div>
    ) : null;

    return (
        <div className="broker-alternative-funds-view">
            <div className="broker-general-view__search-widget">
                <BrokerSearchWidget product={"ALTERNATIVE_FUNDS"} />
            </div>
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="higher-small" section="broker" customClass="col-xs-12">
                        <BrokerTruncatedBreadcrumb
                            titleKey="brokerAlternativeFunds-title"
                            breadcrumbConfig={[
                                {
                                    text: formatText('funds-investments'),
                                    url: MYPROFILE_BROKER_URL,
                                },
                                {
                                    text: formatText('brokerAlternativeFunds-title'),
                                    url: '',
                                },
                            ]}
                        />
                    </OKCover>
                </div>
            </div>
            <div className="grid-view__body">
                <div className="container-fluid grid-view--content-position-positive">
                    <div className="broker-funds-view__broker-risk-indicator">
                        <BrokerRiskIndicatorForAlternativeFunds
                            links={[getPublicSiteUrl(), CNMV_URL]}
                            textContent="brokerAlternativeFunds-riskIndicator_content"
                        />
                    </div>
                    <BrokerAlternativeFundsContractTab
                        history={history}
                        immBrokerMyInvestments={immBrokerMyInvestments}
                        immAccounts={immAccounts}
                        immBrokerWallets={immBrokerWallets}
                        getStocksByContract={getStocksByContract}
                        postWalletAlias={postWalletAlias}
                        setOrdersAndMovementsAccessFrom={setOrdersAndMovementsAccessFrom}
                        setOrdersAndMovementsContract={setOrdersAndMovementsContract}
                        onOpenTraderClick={() => {
                            taggingEventHandled(PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME, 'searchFundButton');
                            onOpenTraderClick
                        }}
                        getContractState={getContractState}
                        immBrokerContractState={immBrokerContractState}
                        immBrokerLandingLoader={immBrokerLandingLoader}
                        BrokerInternalTransferFundsActions={BrokerInternalTransferFundsActions}
                        resetSpecificProduct={resetSpecificProduct}
                        onInternalTransferFundsClick={onInternalTransferFundsClick}
                        handleShowSearchWidget={()=> {
                            taggingEventHandled(PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME, 'searchFundButton');
                            handleShowSearchWidget();
                        }}
                        handleBuySearchClick={() => {
                            taggingEventHandled(PROC_BROKER_ALTERNATIVE_FUNDS_PG_NAME, 'buyFundButton');
                            handleBuySearchClick()
                        }}
                    />

                    <div className="row">
                        <div className="col-xs-12 col-md-8">
                            <section className="row">
                                <div
                                    className={`col-md-12 broker-alternative-funds-view__section-banner`}
                                >
                                    <BrokerInformationAboutProduct
                                        productType={ALTERNATIVE_FUNDS}
                                        hasButton={false}
                                        externalLink={true}
                                        pageName={PROC_BROKER_FUNDS_PG_NAME}
                                        onFooterLinkClick={() => handleBuySearchClick()}
                                    />
                                </div>
                            </section>
                            <section className="broker-alternative-funds-view__section-container">
                                <BrokerAlternativeFundsIntroVideo />
                            </section>
                            <section className="broker-alternative-funds-view__section-container">
                                <div className="broker-alternative-funds-view__section-title">
                                    <FormattedText value="brokerAlternativeFunds-characteristics_title" />
                                </div>
                                <div className="broker-alternative-funds-view__section-characteristics">
                                    <div className="broker-alternative-funds-view__section-characteristics-item">
                                        <img src={numberOne} alt="Number one" />
                                        <div className="broker-alternative-funds-view__section-characteristics-title">
                                            <FormattedText value="brokerAlternativeFunds-characteristics_characteristic1Title" />
                                        </div>
                                        <div className="broker-alternative-funds-view__section-characteristics-content">
                                            <FormattedText value="brokerAlternativeFunds-characteristics_characteristic1Content" />
                                        </div>
                                    </div>
                                    <div className="broker-alternative-funds-view__section-characteristics-item">
                                        <img src={numberTwo} alt="Number two" />
                                        <div className="broker-alternative-funds-view__section-characteristics-title">
                                            <FormattedText value="brokerAlternativeFunds-characteristics_characteristic2Title" />
                                        </div>
                                        <div className="broker-alternative-funds-view__section-characteristics-content">
                                            <FormattedText value="brokerAlternativeFunds-characteristics_characteristic2Content" />
                                        </div>
                                    </div>
                                    <div className="broker-alternative-funds-view__section-characteristics-item">
                                        <img src={numberThree} alt="Number three" />
                                        <div className="broker-alternative-funds-view__section-characteristics-title">
                                            <FormattedText value="brokerAlternativeFunds-characteristics_characteristic3Title" />
                                        </div>
                                        <div className="broker-alternative-funds-view__section-characteristics-content">
                                            <FormattedText value="brokerAlternativeFunds-characteristics_characteristic3Content" />
                                        </div>
                                    </div>
                                    <div className="broker-alternative-funds-view__section-characteristics-item">
                                        <img src={numberFour} alt="Number four" />
                                        <div className="broker-alternative-funds-view__section-characteristics-title">
                                            <FormattedText value="brokerAlternativeFunds-characteristics_characteristic4Title" />
                                        </div>
                                        <div className="broker-alternative-funds-view__section-characteristics-content">
                                            <FormattedText value="brokerAlternativeFunds-characteristics_characteristic4Content" />
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="row">
                                {fundsCTAsObject}
                                <div className="col-md-12 broker-alternative-funds-view__section-call-specialist">
                                    <BrokerInvestmentSpecialist />
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer className="broker-alternative-funds-view__section-footer">
                        <FormattedText value="brokerAlternativeFunds-footer_content" />
                    </footer>
                </div>
            </div>
        </div>
    );
};

BrokerAlternativeFundsView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    getStocksByContract: PropTypes.func.isRequired,
    postWalletAlias: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    getContractState: PropTypes.func,
    immBrokerContractState: PropTypes.object,
    immBrokerLandingLoader: PropTypes.object.isRequired,
    onInternalTransferFundsClick: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func,
    handleShowSearchWidget: PropTypes.func.isRequired,
}

module.exports.BrokerAlternativeFundsView = connect(
    state => ({
        immAccounts: state.accounts,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerContractState: state.brokerContractState,
        immBrokerWallets: state.brokerWallets,
        immBrokerLandingLoader: state.brokerLandingLoader,
    }),
    {
        getStocksByType: BrokerStocksByTypeActions.getStocksByType,
        getStocksContracts: BrokerStocksByContractActions.getWalletList,
        getStocksByContract: BrokerStocksByContractActions.getStocksByWallet,
        setOrdersAndMovementsAccessFrom: BrokerOrdersAndMovementsActions.setAccessFrom,
        postWalletAlias: BrokerStocksByContractActions.postWalletAlias,
        setOrdersAndMovementsContract: BrokerOrdersAndMovementsActions.setContractNumber,
        onInternalTransferFundsClick: BrokerInternalTransferFundsActions.setOriginFund,
        onOpenTraderClick: BrokerOpenTraderActions.openLink,
        getContractState: brokerContractState.getContractState,
        resetSpecificProduct: BrokerProductFiltersSearchActions.resetSpecificProduct,
        handleShowSearchWidget: BrokerSearchWidgetActions.showSearchWidget,
    }
)(withRouter(BrokerAlternativeFundsView));